import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, Validators} from '@angular/forms';
import {ModalComponent} from 'src/app/generico/modal/modal.component';
import { AutenticacionService } from 'src/app/generico/servicio/autenticacion.service';

@Component({
  selector: 'app-recuperar-pass',
  templateUrl: './recuperar-pass.component.html',
  styleUrls: ['./recuperar-pass.component.scss']
})
export class RecuperarPassComponent implements OnInit {
  recuperarForm = this.fb.group({
    usuario: [null, Validators.required]
  });

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<RecuperarPassComponent>,
    public dialog: MatDialog,
    private auth_serv : AutenticacionService
  ) { }

  ngOnInit(): void {
  }

  onSubmit() {
    let form_data = {
        "mail": this.recuperarForm.value.usuario, 
        "app": 1
    }
    this.auth_serv.recuperar_contrasena(form_data);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
